import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLocale, setLocale } from "./i18nRefs.jsx";
import { dict } from "./i18n";
import stilogo from "./sti-logo.png";
import socalgaslogo from "./SoCalGas_logo.webp";

const Footer = (props) => {
  let navigate = useNavigate();
  const [locale, setLocalLocale] = useState(getLocale());
  const [i18n, seti18n] = useState(dict[getLocale()]);

  return (
    <div id="footer" className={"footer"} style={styles.footer}>
      <div className={"text-center"} style={{ padding: "10px" }}>
        <span style={{ fontSize: "small", fontStyle: "italic" }}>
          {i18n.OPERATED_BY}
        </span>
        <br />
        <a href="https://www.sonomatech.com/" target={"_blank"}>
          <img
            src={stilogo}
            alt={"Sonoma Technology, Inc."}
            style={{ height: "32px" }}
          />
        </a>
      </div>
      <div
        id={"featured-3"}
        className={"py-5"}
        style={{ backgroundColor: "lightgray", padding: "10px" }}
      >
        <div className="col-lg-10 mx-auto">


          <p>{i18n.SOCALGAS_AUTHORIZED_CONTRACTOR}</p>

          <p>{i18n.REFERENCES_HEREBY}</p>
          <p>{i18n.REFERENCES_HEREBY_P2}</p>

          <p
            dangerouslySetInnerHTML={{
              __html: i18n.SOCALGAS_TERMSCONDITION_POLICY,
            }}
          ></p>

          <p>{i18n.TRADEMARK_STATEMENT}</p>

          <div className={"text-center"}>
            <a href="https://www.sonomatech.com/" target={"_blank"}>
              <img
                src={stilogo}
                alt={"Sonoma Technology, Inc."}
                style={{ height: "64px" }}
              />
            </a>
          </div>

          <div className={"text-center"} style={{ marginTop: "20px" }}>
            <a href={"https://www.socalgas.com/"} target="_blank">
              <img
                src={socalgaslogo}
                alt={"SoCalGas"}
                style={{ height: "64px" }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  footer: {},
};

export default Footer;
